import type { DrillDefinition } from './types';

export const APP_NAME = '147coach';
export const APP_DOMAIN = '147coach.com';

export const SUBSCRIPTION_PRICE_EUR = 5;
export const COACH_PRICE_EUR = 15;
export const CLUB_PRICE_EUR = 25;

export const TRIAL_DAYS = 14;

export const DRILLS: DrillDefinition[] = [
  {
    id: 'lineup',
    name: 'Line-up Drill',
    description: 'Pot all 15 reds and 6 colours in a line down the table. Trains positional play and cue ball control.',
    ballsInvolved: ['red'],
    targetStat: 'Avg break / positional play',
    icon: '📏',
  },
  {
    id: 'long_pot',
    name: 'Long Pot Drill',
    description: 'Pot reds from the baulk end into corner pockets. Trains long potting accuracy.',
    ballsInvolved: ['red'],
    targetStat: 'Long pot %',
    icon: '↔️',
  },
  {
    id: 'colors_clearance',
    name: 'Colours Clearance',
    description: 'Clear all 6 colours in order from their spots. Trains cue ball control and break building.',
    ballsInvolved: ['yellow', 'green', 'brown', 'blue', 'pink', 'black'],
    targetStat: 'Avg break / colours success',
    icon: '🎯',
  },
  {
    id: 'baulk_colors',
    name: 'Baulk Colours',
    description: 'Pot yellow, green and brown from spots with positional play to each. Trains precision.',
    ballsInvolved: ['yellow', 'green', 'brown'],
    targetStat: 'Potting accuracy',
    icon: '🟡',
  },
  {
    id: 'safety_exchange',
    name: 'Safety Exchange',
    description: 'Alternate safety shots simulating a safety battle. Trains defensive decision making.',
    ballsInvolved: ['red'],
    targetStat: 'Safety success %',
    icon: '🛡️',
  },
  {
    id: 'break_building',
    name: 'Break Building',
    description: 'Open free practice — focus on building the highest break possible. No drill constraints.',
    ballsInvolved: ['red', 'yellow', 'green', 'brown', 'blue', 'pink', 'black'],
    targetStat: 'High break / avg break',
    icon: '🏆',
  },
];

// Firestore collection names
export const COLLECTIONS = {
  USERS: 'users',
  SESSIONS: 'sessions',
  SHOTS: 'shots',           // subcollection under sessions
  STATS: 'stats',           // aggregated stats per user
  DRILLS: 'drillAttempts',
  ADMIN: 'admin',
} as const;